import {BaseNodeType} from '../../../../../@polygonjs/polygonjs/src/engine/nodes/_Base';
import {BaseParamType} from '../../../../../@polygonjs/polygonjs/src/engine/params/_Base';
import {TypedMultipleParam} from '../../../../../@polygonjs/polygonjs/src/engine/params/_Multiple';
import {TypedNumericParam} from '../../../../../@polygonjs/polygonjs/src/engine/params/_Numeric';
// import {OperatorPathParam} from '../../../../../@polygonjs/polygonjs/src/engine/params/OperatorPath';
import {NodePathParam} from '../../../../../@polygonjs/polygonjs/src/engine/params/NodePath';
import {StringParam} from '../../../../../@polygonjs/polygonjs/src/engine/params/String';

import {NodeCodeExporter} from './Node';
// import {BaseNodeObjCodeExporter} from './node/Obj';
// import {BaseNodeSopSubnetworkCodeExporter} from './node/Subnetwork';

import {ParamCodeExporter} from './Param';
import {ParamMultipleCodeExporter} from './param/Multiple';
import {ParamNumericCodeExporter} from './param/Numeric';
// import {ParamOperatorPathCodeExporter} from './param/OperatorPath';
import {ParamNodePathCodeExporter} from './param/NodePath';
import {ParamParamPathCodeExporter} from './param/ParamPath';
import {ParamStringCodeExporter} from './param/String';
import {ParamRampCodeExporter} from './param/Ramp';
import {ParamButtonCodeExporter} from './param/Button';
import {ParamPathParam} from '../../../../../@polygonjs/polygonjs/src/engine/params/ParamPath';
import {ParamType} from '../../../../../@polygonjs/polygonjs/src/engine/poly/ParamType';
import {RampParam} from '../../../../../@polygonjs/polygonjs/src/engine/params/Ramp';
import {ButtonParam} from '../../../../../@polygonjs/polygonjs/src/engine/params/Button';
import {SubnetGlNode} from '../../../../../@polygonjs/polygonjs/src/engine/nodes/gl/Subnet';
import {IfThenGlNode} from '../../../../../@polygonjs/polygonjs/src/engine/nodes/gl/IfThen';
import {ForLoopGlNode} from '../../../../../@polygonjs/polygonjs/src/engine/nodes/gl/ForLoop';
import {SubnetGlCodeExporter} from './node/gl/Subnet';
import {NodesCodeExporterOption} from './Nodes';

export class CodeExporterDispatcher {
	static dispatch_node(node: BaseNodeType, options: NodesCodeExporterOption) {
		if (node instanceof SubnetGlNode || node instanceof IfThenGlNode || node instanceof ForLoopGlNode) {
			return new SubnetGlCodeExporter(node, options);
		}
		return new NodeCodeExporter(node, options);
	}

	// static node(node: BaseNode): NodeCodeExporter {
	// 	return new NodeCodeExporter(node);
	// }
	// static node_obj(node: BaseNode) {
	// 	return new BaseNodeObjCodeExporter(node);
	// }
	// static node_sop_subnetwork(node: BaseNode) {
	// 	return new BaseNodeSopSubnetworkCodeExporter(node);
	// }
	static dispatch_param(param: BaseParamType): ParamCodeExporter<BaseParamType> {
		const paramType = param.type();
		// using comparison with types here instead of using instanceof
		// to ensure that plugins do not have the instanceof messed up
		const multipleTypes = [ParamType.VECTOR2, ParamType.VECTOR3, ParamType.VECTOR4, ParamType.COLOR];
		if (multipleTypes.includes(paramType)) {
			return new ParamMultipleCodeExporter(param as TypedMultipleParam<any>);
		}
		const numericTypes = [ParamType.FLOAT, ParamType.INTEGER, ParamType.BOOLEAN];
		if (numericTypes.includes(paramType)) {
			return new ParamNumericCodeExporter(param as TypedNumericParam<any>);
		}
		if (paramType == ParamType.BUTTON) {
			return new ParamButtonCodeExporter(param as ButtonParam);
		}
		// if (paramType == ParamType.OPERATOR_PATH) {
		// 	return new ParamOperatorPathCodeExporter(param as OperatorPathParam);
		// }
		if (paramType == ParamType.NODE_PATH) {
			return new ParamNodePathCodeExporter(param as NodePathParam);
		}
		if (paramType == ParamType.PARAM_PATH) {
			return new ParamParamPathCodeExporter(param as ParamPathParam);
		}
		if (paramType == ParamType.STRING) {
			return new ParamStringCodeExporter(param as StringParam);
		}
		if (paramType == ParamType.RAMP) {
			return new ParamRampCodeExporter(param as RampParam);
		}
		return new ParamCodeExporter(param);
	}
}
// 	static visit_param(param: BaseParamType) {
// 		return new ParamCodeExporter(param);
// 	}
// 	static param_multiple(param: BaseParam) {
// 		return new ParamMultipleCodeExporter(param);
// 	}
// 	static param_numeric(param: BaseParam) {
// 		return new ParamNumericCodeExporter(param);
// 	}
// 	static param_operator_path(param: BaseParam) {
// 		return new ParamOperatorPathCodeExporter(param);
// 	}
// 	static param_string(param: BaseParam) {
// 		return new ParamStringCodeExporter(param);
// 	}
// 	static param_ramp(param: BaseParam) {
// 		return new ParamRampCodeExporter(param);
// 	}
// }
